/**
 * Fechas “solo calendario” en DD/MM/YYYY sin desfase por zona horaria del navegador.
 * Preferimos el prefijo ISO YYYY-MM-DD (incluye cadenas que empiecen así antes de hora TZ).
 */

/** Normaliza Date, ISO, YYYY-MM-DD o JSON de Carbon a YYYY-MM-DD. */
export function valorFechaAStringCalendario(raw) {
  if (raw == null || raw === '') return null;
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
    const y = raw.getUTCFullYear();
    const m = String(raw.getUTCMonth() + 1).padStart(2, '0');
    const d = String(raw.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  if (typeof raw === 'object') {
    if (raw.date) {
      const fromCarbon = String(raw.date).trim().slice(0, 10);
      return /^\d{4}-\d{2}-\d{2}$/.test(fromCarbon) ? fromCarbon : null;
    }
    return null;
  }
  const s = String(raw).trim();
  if (!s) return null;
  const head = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(head)) return head;
  return s;
}

/** Lee fecha de nacimiento en snake_case, camelCase o anidada en datosEmpleado. */
export function extraerFechaNacimientoEmpleado(emp) {
  if (!emp || typeof emp !== 'object') return null;
  const candidatos = [
    emp.fecha_nacimiento,
    emp.fechaNacimiento,
    emp.datosEmpleado?.fecha_nacimiento,
    emp.datosEmpleado?.fechaNacimiento,
  ];
  for (const c of candidatos) {
    const ymd = valorFechaAStringCalendario(c);
    if (ymd && /^\d{4}-\d{2}-\d{2}$/.test(ymd)) return ymd;
  }
  return null;
}

export function formatFechaSoloDiaDdMmYyyy(raw, emptyLabel = 'N/A') {
  const ymd = valorFechaAStringCalendario(raw);
  if (!ymd) return emptyLabel;
  const head = String(ymd).slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(head)) {
    const [y, mo, da] = head.split('-');
    return `${da}/${mo}/${y}`;
  }

  const s = String(ymd).trim();
  const t = Date.parse(s);
  if (Number.isNaN(t)) return emptyLabel;

  try {
    return new Intl.DateTimeFormat('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'America/Lima',
    }).format(new Date(t));
  } catch (_) {
    const d = new Date(t);
    return `${String(d.getUTCDate()).padStart(2, '0')}/${String(d.getUTCMonth() + 1).padStart(2, '0')}/${d.getUTCFullYear()}`;
  }
}
